import { Link, Paper, styled } from "@mui/material";
import { useTranslation } from "react-i18next";

import { NavLink } from "components/navigation/NavLink";
import { LoadingButton } from "components/buttons/LoadingButton";

interface Props {
  uuid: string;
  isDisabled: boolean;
  isLoading: boolean;
  handleUpload: () => void;
}

export function UploadMeasureFooter(props: Props) {
  const { uuid, handleUpload, isDisabled, isLoading } = props;
  const { t } = useTranslation();

  return (
    <StyledPaper elevation={0}>
      <Link component={NavLink} to={`/${uuid}/measures`}>
        {t("label.cancel")}
      </Link>
      <LoadingButton
        variant="green-contained"
        isLoading={isLoading}
        disabled={isDisabled}
        onClick={handleUpload}
      >
        {t("label.upload")}
      </LoadingButton>
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(2)};
  flex-grow: 1;
  align-items: center;
  justify-content: flex-end;
  .MuiButton-root {
    display: inline-flex;
    gap: ${({ theme }) => theme.spacing(2)};
  }
`;
